import { render, staticRenderFns } from "./UploadPassport.vue?vue&type=template&id=12122b18&"
import script from "./UploadPassport.vue?vue&type=script&lang=js&"
export * from "./UploadPassport.vue?vue&type=script&lang=js&"
import style0 from "./UploadPassport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports